/* eslint-disable react/no-array-index-key */
import {Typography, css, useTheme} from '@mui/material';
import {GetStylesFunction} from '@wallaby-ui/core';
import * as React from 'react';

import {TIMELINE_ANNOTATION_GAP} from './EncounterTimelineAnnotationFormatter';
import {HaidiSchema} from '../../types';
import {TooltipWrapper} from '../TooltipWrapper';

interface OwnProps {
  data: HaidiSchema.components['schemas']['EncounterTimelineEventDto'];
}

type Props = OwnProps;

export const EncounterTimelineDocumentTypeFormatter: React.FC<Props> = ({data}) => {
  const theme = useTheme();
  const styles = getStyles({theme, params: {}});
  return (
    <>
      <div css={styles.documentTypeWrapper}>
        {(data.annotations ?? []).map((v, i) => {
          return (
            <TooltipWrapper key={i} tooltip={v.documentName} maxWidth={300} wrapperCss={styles.tooltipWrapper}>
              <Typography variant='value' css={styles.text}>
                {v.documentName ?? ' '}
              </Typography>
            </TooltipWrapper>
          );
        })}
      </div>
    </>
  );
};

EncounterTimelineDocumentTypeFormatter.displayName = 'EncounterTimelineDocumentTypeFormatter';

const getStyles: GetStylesFunction = (options) => ({
  documentTypeWrapper: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${TIMELINE_ANNOTATION_GAP};
  `,
  tooltipWrapper: css`
    display: block;
    height: 24px;
  `,
  text: css`
    padding: 6px 0 0 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    max-width: 100%;
  `,
});
